import { useAppStore } from '@/core/store'
import type { SceneId } from '@/core/types'

const SCENES: Array<{ id: SceneId; label: string; description: string }> = [
  {
    id: 'forest',
    label: '森林',
    description: '在密林中探索 — EZ-Tree 程序化树木 + GPU 草地',
  },
  {
    id: 'ocean',
    label: '海洋',
    description: '在大海上航行 — Gerstner 波浪 + 浮力 + 小岛',
  },
]

export function MainMenu() {
  const goToScene = useAppStore((s) => s.goToScene)
  const settings = useAppStore((s) => s.settings)
  const updateSettings = useAppStore((s) => s.updateSettings)

  return (
    <div
      role="dialog"
      aria-label="main-menu"
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'radial-gradient(ellipse at center, #0d1f2d 0%, #02060a 100%)',
        color: '#cfe7ff',
        fontFamily: 'system-ui, sans-serif',
        gap: 32,
        zIndex: 10,
      }}
    >
      <h1 style={{ fontSize: 56, margin: 0, letterSpacing: 6 }}>WILD TIDES</h1>
      <p style={{ opacity: 0.7, margin: 0 }}>森林与海洋 · 网页 3D 沙盒闯关 demo</p>

      <div style={{ display: 'flex', gap: 24, marginTop: 16 }}>
        {SCENES.map((s) => (
          <button
            key={s.id}
            type="button"
            onClick={() => goToScene(s.id)}
            style={{
              width: 240,
              padding: '20px 24px',
              background: 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(255,255,255,0.18)',
              borderRadius: 12,
              color: 'inherit',
              cursor: 'pointer',
              textAlign: 'left',
            }}
          >
            <div style={{ fontSize: 22, fontWeight: 600 }}>{s.label}</div>
            <div style={{ fontSize: 13, opacity: 0.65, marginTop: 6 }}>{s.description}</div>
          </button>
        ))}
      </div>

      <fieldset
        style={{
          border: '1px solid rgba(255,255,255,0.15)',
          borderRadius: 8,
          padding: '12px 20px',
          color: 'inherit',
          marginTop: 12,
          minWidth: 480,
        }}
      >
        <legend style={{ padding: '0 8px', opacity: 0.7 }}>设置</legend>

        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 8 }}>
          <span style={{ width: 80, opacity: 0.8 }}>画质</span>
          {(['low', 'medium', 'high'] as const).map((q) => (
            <label key={q} style={{ marginRight: 8, cursor: 'pointer' }}>
              <input
                type="radio"
                name="quality"
                value={q}
                checked={settings.quality === q}
                onChange={() => updateSettings({ quality: q })}
                style={{ marginRight: 4 }}
              />
              {q}
            </label>
          ))}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 8 }}>
          <label style={{ width: 80, opacity: 0.8 }} htmlFor="vol-master">
            主音量
          </label>
          <input
            id="vol-master"
            type="range"
            min={0}
            max={1}
            step={0.05}
            value={settings.masterVolume}
            onChange={(e) => updateSettings({ masterVolume: Number(e.target.value) })}
          />
          <span style={{ opacity: 0.7 }}>{Math.round(settings.masterVolume * 100)}%</span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
          <label style={{ cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={settings.invertY}
              onChange={(e) => updateSettings({ invertY: e.target.checked })}
              style={{ marginRight: 6 }}
            />
            反转 Y 轴
          </label>
          <label style={{ cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={settings.autoDegrade}
              onChange={(e) => updateSettings({ autoDegrade: e.target.checked })}
              style={{ marginRight: 6 }}
            />
            自动降级
          </label>
          <label style={{ cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={settings.showStats}
              onChange={(e) => updateSettings({ showStats: e.target.checked })}
              style={{ marginRight: 6 }}
            />
            显示 FPS
          </label>
        </div>
      </fieldset>
    </div>
  )
}
